/*
    Description: js utility class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/
class Utilities{

    // constructor
    constructor(){
        
        // grab ajax url - this is set in functions.php using wp_localize_script
        this.ajaxurl = (ajax) ? ajax.url : null;
        
        // default loading class name
        this.loadingClass = "--loading";

    }

    // ajax send method - params[obj:{action:[value], data:[value]}]
    async ajax(obj){
        
        //check if data exits
        if((obj.action)&&(obj.data)){
            
            //pass class names
            const loadingClassName = this.loadingClass;

            //init XML request
            const xhr = new XMLHttpRequest();         

            // make a promise - resolve:error
            let promise = new Promise((res, err) =>{

                //connect to file
                xhr.open("POST", `${this.ajaxurl}?action=${obj.action}`, true);

                //setup headers
                xhr.setRequestHeader("Access-Control-Allow-Headers", "*");

                // upload progress
                xhr.upload.addEventListener("progress", function(e){

                    // check if loading bar exists
                    if(obj.loadingBar){

                        // loaded percentage
                        let loaded = Math.floor((e.loaded/e.total) * 100);

                        // if loadig bar is available
                        obj.loadingBar.style.width = `${loaded}%`;

                    }

                });

                // check on state change
                xhr.addEventListener("readystatechange", function(){
                    
                    // request complete
                    if(this.readyState === XMLHttpRequest.DONE){

                        // status 0-299 should be ok
                        if(this.status < 300){
                            
                            //set response
                            res(this.responseText);

                        // somethings not right
                        }else{

                            // set error
                            err(this.statusText)
                        
                        }

                        // check if loading exists and remove class
                        if(obj.loading) obj.loading.classList.remove(loadingClassName);

                        // reset loading bar
                        if(obj.loadingBar){ 
                            
                            //reset width
                            obj.loadingBar.style.width = "0%";
                            
                        }

                    }

                });

                //send data
                xhr.send(obj.data);

            });

            //return promise
            return promise;

        }

    }

}    

// export
export default Utilities;